/**
 * 空のCSV項目ガイドコンポーネント
 *
 * CSVカラムが未設定の時に表示するガイダンス
 */

import { Text, Paper, Stack, Group, Button } from "@mantine/core";
import { Plus, LayoutTemplate, FileType } from "lucide-react";

interface EmptyColumnsGuideProps {
  onAddColumn: () => void;
  onOpenTemplateModal: () => void;
}

/**
 * カラム未設定時のガイド表示
 */
export function EmptyColumnsGuide({ onAddColumn, onOpenTemplateModal }: EmptyColumnsGuideProps) {
  return (
    <Paper withBorder p="xl" radius="md" bg="light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))">
      <Stack align="center" gap="md">
        <FileType size={40} color="var(--mantine-color-gray-5)" />
        <Stack gap="xs" align="center">
          <Text size="sm" fw={500}>CSVの出力項目がまだ設定されていません</Text>
          <Text size="xs" c="dimmed" ta="center">
            「項目を追加」で1つずつ作成するか、<br />
            「テンプレート適用」でまとめて設定できます。
          </Text>
          <Text size="xs" c="blue" ta="center">
            💡 右の「サンプルの伝票から項目を抽出」で実際の伝票を解析すると、<br />
            AI読取項目を選択式で簡単に設定できます。
          </Text>
        </Stack>
        <Group>
          <Button
            variant="outline"
            leftSection={<Plus size={14} />}
            size="sm"
            onClick={onAddColumn}
          >
            項目を追加
          </Button>
          <Button
            variant="default"
            size="sm"
            leftSection={<LayoutTemplate size={14} />}
            onClick={onOpenTemplateModal}
          >
            テンプレート適用
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
